var _defs, _path, _path2, _polygon, _polygon2, _path3, _rect, _rect2, _polygon3, _rect3, _rect4, _rect5, _rect6, _rect7, _path4, _polygon4, _path5, _polygon5, _polygon6, _path6, _polygon7, _path7, _polygon8, _polygon9, _path8, _path9, _polygon10, _polygon11, _path10, _polygon12, _path11, _path12, _polygon13;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNegativeCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 206.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 280.06,
    y1: 110.76,
    x2: 342.57,
    y2: 48.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b47e11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b68011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bb8710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c5920e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d2a30c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e4b909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fad406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ffda05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b47e11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 949.11,
    y1: -22.27,
    x2: 1092.67,
    y2: 72.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 932.5,
    y1: 1.15,
    x2: 1076.06,
    y2: 95.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 915.89,
    y1: 24.57,
    x2: 1059.44,
    y2: 119.25,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.93,98.17a133.07,133.07,0,0,1-41.8-6.89L20,90.9,22.27,84l1.14.38a125.74,125.74,0,0,0,39.52,6.53c33.38,0,37-11.2,37-16,0-9.21-11-11.31-35.81-12.54C44.89,61.49,21,60.42,21,41.48,21,27.81,34.92,20,59.22,20A190,190,0,0,1,97.9,24.29l1.19.26-1.57,7.09-1.18-.27a183.31,183.31,0,0,0-37.12-4.14c-19.69,0-31,5.19-31,14.25,0,11.12,15.7,12.71,36.21,13.63,21,1,42.73,2.12,42.73,19.79C107.17,81.9,102.86,98.17,62.93,98.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M796.1,98.17c-31,0-45.4-10.16-45.4-32V23.48H758V66.19c0,17.33,11.41,24.73,38.15,24.73s38.16-7.4,38.16-24.73V23.48h7.25V66.19C841.51,88,827.08,98.17,796.1,98.17Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.72 94.65 231.72 33.35 185.61 86.8 139.48 33.35 139.48 94.65 132.22 94.65 132.22 13.83 185.61 75.69 238.98 13.83 238.98 94.65 231.72 94.65"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "311.31 30.2 267.82 96.44 261.76 92.46 311.31 16.98 360.87 92.46 354.81 96.44 311.31 30.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.93,63.15h28.6c15,0,22.23-5.66,22.23-17.31,0-12-7.08-17.52-22.29-17.52H391V94.65h-7.25V21.06h58.76c24.42,0,29.55,13.47,29.55,24.78,0,9.17-3.83,24.56-29.49,24.56h-5l30.52,20.73-4.07,6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 494.23,
    y: 21.06,
    width: 82.81,
    height: 7.26
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 532,
    y: 23.48,
    width: 7.26,
    height: 71.17
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "647.85 97.07 647.85 23.73 655.1 23.73 655.1 89.81 723.74 89.81 723.74 97.07 647.85 97.07"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 908.03,
    y: 4.97,
    width: 7.26,
    height: 108.2,
    transform: "translate(274.38 713.65) rotate(-49.47)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 857.56,
    y: 55.44,
    width: 108.2,
    height: 7.26,
    transform: "translate(180.39 606.65) rotate(-40.53)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 981.73,
    y: 21.06,
    width: 77.17,
    height: 7.26
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 981.73,
    y: 55.44,
    width: 77.17,
    height: 7.26
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 981.73,
    y: 89.82,
    width: 77.17,
    height: 7.26
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.72,185.35l-17-13.43v13.43h-4V153.54h14.63c7,0,11.37,3.56,11.37,9.3s-4.08,9.27-11.18,9.27H201L218,185.35Zm-6.12-17c2.67,0,7.14-.72,7.14-5.54,0-5-5-5.57-7.14-5.57H194.74v11.11Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "225.69 185.35 225.69 153.54 250.53 153.54 250.53 157.25 229.64 157.25 229.64 166.33 245.22 166.34 245.22 170.02 229.64 170.02 229.64 181.6 250.54 181.6 250.54 185.35 225.69 185.35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272,151.74l17.84,33.67h-4.36l-4-7.68H262.4l-4.09,7.68h-4.43Zm7.62,22.44L272,159.59l-7.72,14.59Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "295.46 185.35 295.46 153.54 299.42 153.54 299.41 181.61 318.39 181.61 318.39 185.35 295.46 185.35"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "341.22 185.35 341.22 153.54 366.06 153.54 366.06 157.25 345.17 157.25 345.17 166.33 360.75 166.34 360.75 170.02 345.17 170.02 345.17 181.6 366.07 181.6 366.07 185.35 341.22 185.35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.63,185.66a27.06,27.06,0,0,1-14-3.75l-.53-.34,2.18-3.14.49.3a23.64,23.64,0,0,0,11.85,3.2h.25c5.2-.06,8.43-2.05,8.44-5.19,0-2.7-1.6-3.87-7.17-5.18l-4.28-1c-6.93-1.62-10-4.32-10.08-8.77,0-5,4.84-8.47,12.14-8.54h.21A22.85,22.85,0,0,1,397,156.59l.52.33-2.1,3.17-.5-.32a18.1,18.1,0,0,0-9.51-2.81h-.26c-5.2.09-8.29,1.91-8.25,4.88,0,2.48,2,3.91,7,5.09l4.45,1c7,1.62,9.9,4.16,9.94,8.74a7.53,7.53,0,0,1-2.21,5.43c-2.22,2.25-5.91,3.5-10.36,3.52Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "414.51 185.35 414.51 157.28 402.86 157.28 402.83 153.54 430.09 153.54 430.09 157.28 418.47 157.28 418.47 185.35 414.51 185.35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.48,151.74l17.84,33.67H461l-4-7.68H437.85l-4.09,7.68h-4.43Zm7.62,22.44-7.65-14.59-7.72,14.59Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "475.72 185.35 475.72 157.28 464.06 157.28 464.04 153.54 491.3 153.54 491.3 157.28 479.68 157.28 479.68 185.35 475.72 185.35"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "498.45 185.35 498.45 153.54 523.29 153.54 523.29 157.25 502.4 157.25 502.4 166.33 517.98 166.34 517.98 170.02 502.4 170.02 502.4 181.6 523.3 181.6 523.3 185.35 498.45 185.35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M547.56,185.35V153.54l11,0c10.75,0,17.93,6.42,17.93,16s-7.2,15.86-17.93,15.86Zm4-3.71h7c8.75,0,14-4.55,14-12.14s-5.22-12.22-14-12.25h-7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.54,185.91c-9.49,0-16.92-7.22-16.92-16.44S591.05,153,600.54,153s17,7.24,17,16.48S610.07,185.91,600.54,185.91Zm0-29.12a12.66,12.66,0,1,0,13,12.69C613.57,162.24,608,156.79,600.54,156.79Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "651.67 185.35 630.38 159.72 630.38 185.35 626.41 185.35 626.41 153.55 630.09 153.55 651.41 179.24 651.41 153.54 655.36 153.54 655.36 185.35 651.67 185.35"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "666.01 185.35 666.01 153.54 690.85 153.54 690.85 157.25 669.96 157.25 669.96 166.33 685.54 166.34 685.54 170.02 669.96 170.02 669.96 181.6 690.87 181.6 690.87 185.35 666.01 185.35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.06,185.66a27.08,27.08,0,0,1-14-3.75l-.53-.34,2.18-3.14.49.3a23.64,23.64,0,0,0,11.85,3.2h.25c5.2-.06,8.43-2.05,8.44-5.19,0-2.7-1.6-3.87-7.17-5.18l-4.28-1c-6.93-1.62-10-4.32-10.08-8.77,0-5,4.84-8.47,12.14-8.54h.22a22.81,22.81,0,0,1,11.87,3.35l.52.33-2.1,3.17-.5-.32a18.09,18.09,0,0,0-9.5-2.81h-.26c-5.21.09-8.3,1.91-8.26,4.88,0,2.48,2,3.91,7,5.09l4.45,1c7,1.62,9.9,4.16,9.94,8.74a7.51,7.51,0,0,1-2.21,5.42c-2.22,2.25-5.9,3.51-10.36,3.53Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "752.21 161.94 752.21 185.35 748.26 185.35 748.26 153.54 751.97 153.54 765.39 178.82 778.92 153.54 782.57 153.54 782.57 185.35 778.62 185.35 778.62 161.97 765.42 186.62 752.21 161.94"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M806.32,151.74l17.83,33.67H819.8l-4-7.68H796.69l-4.09,7.68h-4.44Zm7.61,22.44-7.65-14.59-7.72,14.59Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M850.69,185.35l-17-13.43v13.43h-4V153.54h14.64c7,0,11.36,3.56,11.36,9.3s-4.07,9.27-11.18,9.27h-4.64L857,185.35Zm-6.12-17c2.66,0,7.13-.72,7.13-5.54,0-5-5-5.57-7.13-5.57H833.71v11.11Z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "872.52 185.35 872.52 157.28 860.87 157.28 860.85 153.54 888.11 153.54 888.11 157.28 876.48 157.28 876.48 185.35 872.52 185.35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNegativeCenter);
export default __webpack_public_path__ + "static/media/logo_negative_center.71869fc767a57313aefe0e904ce38c60.svg";
export { ForwardRef as ReactComponent };